import {
    useMemo,
} from 'react'

import Card from 'app/shared-components/Card'
import RichTable from 'app/shared-components/RichTableReduxWrapper'
import useLoadFilters from 'app/common/DomainObject/hooks/useLoadFilters'
import useRequestTable from 'app/hooks/useRequestTable'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import SkyNetPagination, {
    useSkyNetPagination,
} from 'app/shared-components/SkyNetPagination'

import useDamageTrackingRoutes from 'app/SkyNetRoutes/hooks/useDamageTrackingRoutes'
import request from 'app/requests/Container/Container.requests'
import {
    DamageByContainerType,
} from '../../containers.types'
import columns from './damages.columns'
import useStyles from './Damages.style'

export default function DamagesByContainer({
    id: serialNumber,
}: Readonly<{
    id: string,
}>) {
    const DamageTrackingRoutes = useDamageTrackingRoutes()
    const {
        classes,
    } = useStyles()
    const paginationOptions = useSkyNetPagination(25)

    const {
        onParamsChange,
        loadData,
    } = useRequestTable<{ data: DamageByContainerType[] }>({
        config: request.getDamageByContainer,
        params: {
            serialNumber,
        },
        key: RequestKeys.getDamageByContainer,
        keepPreviousData: true,
        withPagination: !!paginationOptions,
        paginationOptions,
    })

    const injectLoadFilters = useLoadFilters(request.damageByContainerCountRequest(serialNumber))
    const columnsWithFilters = useMemo(() => {
        return injectLoadFilters(columns)
    }, [injectLoadFilters])

    const onRowClick = ({
        id,
    }: {
        id: number,
    }) => {
        DamageTrackingRoutes.Damages.Update.navigate({
            params: {
                key: id,
            },
        })
    }

    return (
        <>
            <Card
                contentClass={classes.wrapper}
                title="Damages"
                titleClass={classes.title}
            >
                <RichTable
                    configName="DamageTable"
                    name="Damages"
                    load={loadData}
                    onParamsChange={onParamsChange}
                    columns={columnsWithFilters}
                    className={classes.tableContent}
                    classNames={{
                        contentWrapper: classes.tableContentWrapper,
                    }}
                    onRowClick={onRowClick}
                />
            </Card>
            <div className={classes.paginationWrapper}>
                <SkyNetPagination
                    total={paginationOptions.matches}
                    rowsPerPage={paginationOptions.rows}
                    page={paginationOptions.page}
                    onChange={paginationOptions.onChange}
                />
            </div>
        </>
    )
}
